<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            {{ id ? "Editar" : "Registrar" }} Dispositivo {{ id || "" }}
            <router-link :to="{ name: 'Dispositivos' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody v-if="id && isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>
          <CCardBody v-else>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.serie.$model"
                  :isValid="checkIfValid('serie')"
                  label="Número de serie:"
                  placeholder="Serie..."
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.nombre.$model"
                  :isValid="checkIfValid('nombre')"
                  label="Nombre del dispositivo:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9">
                <label>Ubicacion raiz:</label>
                <v-select
                  v-model="ubicacion"
                  :options="ubicaciones"
                  class="margin-multi"
                  :loading="isLoadingPage"
                  placeholder="Selecciona una ubicación"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
                <!-- <CSelect
                  :value.sync="$v.ubicacion.$model"
                  :isValid="checkIfValid('ubicacion')"
                  :horizontal="{ input: 'col-sm-12' }"
                  :options="ubicaciones"
                  placeholder="Selecciona una ubicación"
                  invalidFeedback="Campo requerido"
                />-->
                <!-- <v-select
                  :value.sync="$v.ubicacion.$model"
                  :isValid="checkIfValid('ubicacion')"
                  :options="ubicaciones"
                  invalidFeedback="Campo requerido"
                  class="margin-multi"
                  placeholder="Selecciona una ubicación"
                />-->
              </CCol>
              <!-- <CCol v-if="ubicacion" class="d-flex align-items-center pt-4 py-3 pl-0" sm="1">
                <div @click="resetCombo()">
                  <CIcon size="lg" class="text-danger" name="cil-x-circle" />
                </div>
              </CCol>-->
            </CRow>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.ultima_alta_id.$model"
                  :isValid="checkIfValid('ultima_alta_id', 0)"
                  label="Última alta id:"
                  placeholder="ultima_alta_id..."
                  invalidFeedback="Campo requerido"
                  type="number"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.ultima_baja_id.$model"
                  :isValid="checkIfValid('ultima_baja_id',0)"
                  label="Última baja id:"
                  placeholder="ultima baja id..."
                  invalidFeedback="Campo requerido"
                  type="number"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha de última baja:</label>
                <CInput
                  :value.sync="$v.ultima_baja_fecha.$model"
                  :isValid="checkIfValid('ultima_baja_fecha',0)"
                  type="datetime-local"
                  :horizontal="{ input: 'col-sm-12' }"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.ultima_modificacion_id.$model"
                  :isValid="checkIfValid('ultima_modificacion_id',0)"
                  label="Última modificación id:"
                  placeholder="ultima modificación id..."
                  invalidFeedback="Campo requerido"
                  type="number"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha de última modificación:</label>
                <CInput
                  :value.sync="$v.ultima_modificacion_fecha.$model"
                  :isValid="checkIfValid('ultima_modificacion_fecha',0)"
                  type="datetime-local"
                  :horizontal="{ input: 'col-sm-12' }"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CAlert
                  fade
                  color="success"
                  class="my-1"
                  :show.sync="currentAlertCounter"
                  >Guardado con éxito.</CAlert
                >
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Dispositivos' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>

            <CButton
              @click="addDispositivo()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Dispositivo"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
        >{{ error }}</CModal
      >
    </CRow>
  </div>
</template>

<script>
import moment from "moment";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  minValue,
} from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "NuevoDispositivo",

  components: {
    vSelect
  },

  data() {
    return {
      id: this.$route?.params?.id||undefined,
      ubicaciones: [],
      serie: "",
      nombre: "",
      ubicacion: null,
      ultima_alta_id: "",
      ultima_baja_id: "",
      ultima_baja_fecha: "",
      ultima_modificacion_id: "",
      ultima_modificacion_fecha: "",
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      warningModal: false,
      error: "",
      itemModal: { id: "", name: "" }
    };
  },

  mixins: [validationMixin],
  validations: {
    nombre: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(25)
    },
    serie: {
      required
    },
    //ultima_alta_id: {custom},
    //ultima_baja_id: {custom},
    //ultima_baja_fecha: {custom},
    //ultima_modificacion_id: {custom},
    //ultima_modificacion_fecha: {custom},


    ultima_alta_id: {
      minLength: minValue(0),
    },
    ultima_baja_id: {
      minLength: minValue(0),
    },
    ultima_baja_fecha: {
    },
    ultima_modificacion_id: {
      minLength: minValue(0),
    },
    ultima_modificacion_fecha: {
    },
    // ubicacion: {
    //   required
    // }
  },

  computed: {
    isValidDispositivo() {
      return !this.$v.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }

    // isValidUbicacion() {
    //   return !this.$v.ubicacion.$invalid;
    // }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },

  created() {
    this.isLoadingPage = true;

    Promise.all([
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->pertenece_id",
              value: 0,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      }),
      ...(this.id
        ? [
            this.$store.dispatch("customHTTP", {
              schema: "dispositivos",
              filter: {
                where: [
                  {
                    field: "id",
                    value: this.id,
                    operator: "="
                  }
                ]
              }
            })
          ]
        : [])
    ])
      .then(([res, items]) => {
        this.ubicaciones = res.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
        if (this.id) {
          const item = items.data[0];
          this.serie = item.payload.serie;
          this.nombre = item.payload.nombre;
          this.ubicacion =
            this.ubicaciones.find(
              f => (f.value === item.payload.ubicacion_raiz_id)
            ) || null;
          this.ultima_alta_id = item.payload.ultima_alta_id;
          this.ultima_baja_id = item.payload.ultima_baja_id;
          this.ultima_baja_fecha = item.payload.ultima_baja_fecha;
          this.ultima_modificacion_id = item.payload.ultima_modificacion_id;
          this.ultima_modificacion_fecha =
            item.payload.ultima_modificacion_fecha;
        }
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    addDispositivo() {
      this.validateDispositivo();

      if (this.isValidDispositivo) {
        if (!this.ubicacion) {
          this.error = "El campo ubicación es obligatorio";
          this.warningModal = true;
          return;
        }
        this.isLoading = true;
        debugger
        console.log({ubicacion_raiz_id: this.ubicacion ? this.ubicacion.value : ""})
        this.$store
          .dispatch("customActualizarHTTP", {
            schema: "dispositivos",
            id: this.id,
            payload: {
              nombre: this.nombre,
              serie: this.serie,
              ultima_alta_id: Number(this.ultima_alta_id),
              ultima_baja_id: Number(this.ultima_baja_id),
              ultima_baja_fecha: this.ultima_baja_fecha
                ? moment(this.ultima_baja_fecha).format("YYYY-MM-DD HH:mm:ss")
                : "",
              ultima_modificacion_id: Number(this.ultima_modificacion_id),
              ultima_modificacion_fecha: this.ultima_modificacion_fecha
                ? moment(this.ultima_modificacion_fecha).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                : "",
              ubicacion_raiz_id: this.ubicacion ? this.ubicacion.value : ""
            }
          })
          .then(() => {
            this.currentAlertCounter = 6;
            // console.log(res.data);
            // this.$router.push({ name: "Dispositivos" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.isLoading = false;
            if(this.id){
              this.$router.push({ name: 'Dispositivos' });
            }
          });
      }
    },
    checkIfValid(fieldName, required=true) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || required&&field.$model === "");
    },
    validateDispositivo() {
      this.$v.$touch();
      // this.$v.ubicacion.$touch();
    },
    updateCombos() {
      const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->pertenece_id",
              value: 0,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      this.isLoadingPage = true;
      const cat = [];

      if (this.ubicacionRaizValue) {
        cat.push(ubicacionTemplateRaiz);
      } else {
        cat.push(ubicacionTemplateNoRaiz);
      }

      Promise.all(cat)
        .then(([res]) => {
          this.ubicaciones = res.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });
        })
        .finally(() => (this.isLoadingPage = false));
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
